<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Requerimientos de Traslado</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-5">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'inventario-req_traslado-nuevo', params: {} }"
              >
                <i class="fa fa-pencil"></i>
                Nuevo Requerimiento de Traslado
              </router-link>
            </div>
            <div class="col-sm-12">
              <div class="row justify-content-sm-end">
                <UsuariosSelectComponent
                  class="col-sm-3"
                  style="display: block"
                  :current="filter"
                  @change="filterData()"
                  @onChange="filterData()"
                />
              </div>
              <div class="form-inline justify-content-sm-end">
                <button
                  type="button"
                  @click="modalTiendaSelect()"
                  class="btn btn-dark btn-sm"
                >
                  Cambiar Tienda
                  <i class="fas fa-history"></i>
                </button>
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar Numero"
                  v-model="filter.numero"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filter.estado_str"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <ReqTrasladoTableComponent :dataTabla="datatabla2" />
        <PaginationComponent
          :currentPage="currentPage"
          :data="datatabla2"
          @pagechanged="filterData"
        />
      </div>
    </div>
    <div
      class="modal fade"
      id="modalTiendaSelect"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Elije una tienda
            </h5>
          </div>
          <div class="modal-body">
            <select
              class="form-control col-12"
              v-model="filter.tienda"
              @change="filterData()"
            >
              <option
                v-for="(item, key) in tiendas"
                :value="item.codigo"
                :key="key"
              >
                 {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="clearFilterData()"
            >
              Cerrar
              <small>(Se mostraran todas las tiendas)</small>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import ReqTrasladoTableComponent from "@/components/inventario/req_traslado/ReqTrasladoTableComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    ReqTrasladoTableComponent,
    UsuarioEnTablaComponent,
    UsuariosSelectComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      datatabla2: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        fecha_creacion: "",
        numero: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    this.refreshData();
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    $("#modalTiendaSelect").modal("show");
  },
  methods: {
    modalTiendaSelect() {
      $("#modalTiendaSelect").modal("show");
    },
    refreshData() {
      DynamicService.fetch("inv", "req_traslado", {}).then((response) => {
        this.datatabla2 = response.data;
      });
    },
    filterData(page) {
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("inv", "req_traslado", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        fecha_creacion: this.filter.fecha_creacion,
        tienda: this.filter.tienda,
        estado: this.filter.estado_str,
        usuario: this.filter.usuario.id,
        numero: this.filter.numero,
      }).then((response) => {
        this.datatabla2 = response.data;
        $("#modalTiendaSelect").modal("hide");
      });
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.numero = "";
      this.filter.usuario = "";
      this.filter.tienda = "";
    },
  },
};
</script>
